import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { candidateAvailabilityStatus } from '@containers/App/app.constant';
import postData from '@utils/postData';
import { callSafely } from '@utils/sagaHelper';
import { catchError } from '@utils/sentry';
import { addScheduleOverrideFailure, addScheduleOverrideRequest, addScheduleOverrideSuccess } from './slice';
import { UPSERT_AVAILABILITY } from './queries';
export class PartialAvailabilityFailure extends Error {
    succeededRecords;
    constructor(succeededRecords, cause) {
        super(cause.message || 'Failed to store some availability slots.');
        this.succeededRecords = succeededRecords;
        this.name = 'PartialAvailabilityFailure';
    }
}
function* upsertAvailabilitySlot(override) {
    const response = (yield call(postData, {
        queryString: UPSERT_AVAILABILITY,
        payload: {
            id: override.id,
            from: override.from_date,
            to: override.to_date,
            availability_status: candidateAvailabilityStatus.AVAILABLE,
        },
        spreadPayload: true,
    }));
    const record = response?.data?.can_upsert_availability;
    if (!record) {
        throw new Error('Failed to store availability.');
    }
    return { ...record, from_date: override.from_date, to_date: override.to_date };
}
export function* addScheduleOverrideWorker({ payload }) {
    const { data, callback } = payload;
    try {
        const overrideArray = data?.overrideArray ?? [];
        const results = (yield all(overrideArray.map((override) => call(() => callSafely(upsertAvailabilitySlot, override)))));
        const succeeded = results.filter((result) => result.status === 'fulfilled');
        const failed = results.filter((result) => result.status === 'rejected');
        if (failed.length) {
            throw new PartialAvailabilityFailure(succeeded.map((result) => result.value), failed[0].error);
        }
        yield put(addScheduleOverrideSuccess());
        if (callback?.onSuccess) {
            yield call(callback.onSuccess, succeeded.map((result) => result.value));
        }
    }
    catch (error) {
        yield call(catchError, {
            title: 'Add schedule override worker failed',
            error: error,
            skipToast: true,
        });
        yield put(addScheduleOverrideFailure());
        if (callback?.onError) {
            yield call(callback.onError, error);
        }
    }
}
export function* addScheduleOverrideWatcher() {
    yield takeLatest(addScheduleOverrideRequest.type, addScheduleOverrideWorker);
}
export function* candidateAvailabilityRootSaga() {
    yield fork(addScheduleOverrideWatcher);
}
